import React from 'react';
import { useDispatch } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { reset as resetUser } from 'component/user/actions';

const Logout = () => {
    const dispatch = useDispatch();

    dispatch(resetUser());

    return <Navigate to="/login" replace={true} />;
};

export default Logout;
